import { IComponentOptions } from "angular";
import { SelectMachineModalController } from "./controller";

export const vsComponentName = "selectMachineModalComponent";

export const selectMachineModalComponentOptions: IComponentOptions = {
  controller: SelectMachineModalController,
  controllerAs: "componentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    modalInstance: "=",
    resolve: "=",
  },
};
